import React, { useState, useEffect, useRef } from "react";
import { Helmet } from "react-helmet";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import axios from "axios";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import "../../../../style.scss";
import { currencies } from "../../../../../../../static/currencies";
import { useAppContext } from "../../../../../../../AppContext";

const initialFieldState = {
  name: {
    value: "",
    message: "",
    state: null,
  },
  levels: {
    value: [
      {
        id: 1,
        name: "Admin",
        state: true,
      },
    ],
    message: "",
    state: true,
  },
  accntExp: {
    value: new Date(
      new Date().getFullYear() + 1,
      new Date().getMonth(),
      new Date().getDate()
    ),
    message: "",
    state: true,
  },
};

function CreateGroup() {
  const { user, chimeraserv } = useAppContext();
  const [selectedCurrency, setSelectedCurrency] = useState(currencies[0]);
  const [reset, setReset] = useState(Date.now());
  const [title] = useState("Create Client | Chimera Solutions | Insights");
  const [form, setForm] = useState({ state: null, message: "" });
  const [field, setField] = useState({ ...initialFieldState });
  const newLevelRef = useRef(null);
  const timeRef = useRef(null);

  const headers = {
    Authorization: user.data.usrKey,
    "Content-Type": "application/json",
    Accept: "application/json",
  };

  const renderTitle = () => (
    <Helmet>
      <title>{title}</title>
    </Helmet>
  );

  const dateChange = (date) => {
    setField((prev) => ({
      ...prev,
      accntExp: {
        ...prev.accntExp,
        value: date,
        state: true,
      },
    }));
  };

  const validateFields = () => {
    setForm((prev) => ({ ...prev, state: false }));

    if (field.name.state && field.levels.state) {
      setForm((prev) => ({ ...prev, state: true }));
    }
  };
  // Call validateFields after field updates
  useEffect(() => {
    validateFields();
  }, [field.name.state, field.levels.state]);

  const validateLevelStates = () => {
    const states = field.levels.value.filter((data) => data.state).length;

    if (field.levels.value.length === states) {
      setField((prev) => ({
        ...prev,
        levels: {
          ...prev.levels,
          state: true,
        },
      }));
      setTimeout(() => validateFields(), 150);
    } else {
      setField((prev) => ({
        ...prev,
        levels: {
          ...prev.levels,
          state: false,
        },
      }));
      setTimeout(() => validateFields(), 150);
    }
  };

  const checkField = (data) => {
    clearTimeout(timeRef.current);
    timeRef.current = setTimeout(async () => {
      if (data.getAttribute("data-field")) {
        const fieldName = data.getAttribute("data-field");
        const key = data.getAttribute("data-key");

        switch (fieldName) {
          case "levels":
            let state = true;
            let message = "";

            if (
              data.id === "name" &&
              field.levels.value[key].name.length <= 3
            ) {
              state = false;
              message = "Group name should be minimum of 4 characters";
            }

            if (
              data.id === "id" &&
              (!field.levels.value[key].id ||
                field.levels.value[key].id < 1 ||
                typeof field.levels.value[key].id !== "number")
            ) {
              state = false;
              message = "user level should be on or between level 1 - 9";
            }

            if (
              data.id === "id" &&
              field.levels.value.filter(
                (value) => value.id === Number(data.value)
              ).length > 1 &&
              field.levels.value.length >= 2
            ) {
              state = false;
              message = "user level exist";
            }

            setField((prev) => {
              const value = prev.levels.value.map((value, index) => {
                if (index === Number(key)) {
                  return {
                    ...value,
                    message: message,
                    state: state,
                  };
                }
                return value;
              });

              return {
                ...prev,
                levels: {
                  ...prev.levels,
                  value: value,
                  message: "",
                  state: null,
                },
              };
            });
            setTimeout(() => validateLevelStates(), 100);
            break;
          default:
            break;
        }
      } else {
        switch (data.id) {
          case "name":
            if (data.value.length) {
              let state = true;
              let message = "";

              if (data.value.length <= 3) {
                state = false;
                message = "Group name should be minimum of 4 characters \n";
              }

              try {
                const response = await axios.get(
                  chimeraserv.urlGet + "/group",
                  { headers }
                );
                if (
                  response.data.find((result) => result.name === data.value)
                ) {
                  state = false;
                  message = "client name already exist \n";
                }
              } catch (error) {
                // handle error if needed
              }

              setField((prev) => ({
                ...prev,
                [data.id]: {
                  ...prev[data.id],
                  value: data.value,
                  state: state,
                  message: message,
                },
              }));

              //setTimeout(() => validateFields(), 150);
            }
            break;
          default:
            break;
        }
      }
    }, 500);
  };

  const valueChanged = (event) => {
    const element = event.target;

    if (element.getAttribute("data-field")) {
      const fieldName = element.getAttribute("data-field");
      const key = element.getAttribute("data-key");

      setField((prev) => {
        const value = prev[fieldName].value.map((data, index) => {
          let newValue = element.value;

          if (element.id === "id") {
            newValue = parseInt(element.value);
          }

          if (index === Number(key)) {
            return {
              ...data,
              [element.id]: newValue,
            };
          }

          return data;
        });

        return {
          ...prev,
          [fieldName]: {
            ...prev[fieldName],
            value: value,
            message: "",
            state: null,
          },
        };
      });
    } else {
      setField((prev) => ({
        ...prev,
        [element.id]: {
          ...prev[element.id],
          value: element.value,
          message: "",
          state: null,
        },
      }));
    }

    setForm((prev) => ({ ...prev, state: false }));
    checkField(element);
  };

  const checker = (state) => {
    let check = {
      icon: "check-circle",
      style: "null",
    };

    switch (state) {
      case true:
        check = {
          icon: "check-circle",
          style: "correct",
        };
        break;
      case false:
        check = {
          icon: "times-circle",
          style: "wrong",
        };
        break;
      default:
        break;
    }

    return check;
  };

  const resetForm = () => {
    setReset(Date.now());
    setField({ ...initialFieldState });
    setForm({ state: null, message: "" });
    setSelectedCurrency(currencies[0]);
  };

  const add = (name) => {
    if (!name) {
      alert("enter a valid level name");
    } else {
      setField((prev) => ({
        ...prev,
        levels: {
          ...prev.levels,
          value: [
            ...prev.levels.value,
            {
              id: parseInt(prev.levels.value.length + 1),
              name: name,
              state: true,
            },
          ],
          message: "",
          state: true,
        },
      }));
      setTimeout(() => validateLevelStates(), 100);
      newLevelRef.current.value = "";
    }
  };

  const remove = (key) => {
    const newLevels = field.levels.value.filter((_, index) => key !== index);

    setField((prev) => ({
      ...prev,
      levels: {
        ...prev.levels,
        value: newLevels,
        message: "",
        state: null,
      },
    }));
    setTimeout(() => validateLevelStates(), 100);
  };

  const submit = async () => {
    setForm((prev) => ({ ...prev, state: false, message: "" }));

    try {
      const response = await axios.post(
        `${chimeraserv.urlPost}/group/create/group`,
        {
          name: field.name.value,
          levels: field.levels.value,
          accntExp: field.accntExp.value,
          baseCurr: selectedCurrency,
        },
        { headers }
      );

      if (response.data && !response.data.__v) {
        resetForm();
        setForm((prev) => ({ ...prev, message: "Group Created" }));
      }
    } catch (error) {
      console.error("Error details:", {
        message: error.message,
        response: error.response?.data,
        status: error.response?.status,
        url: error.config?.url,
      });
      setForm((prev) => ({ ...prev, message: JSON.stringify(error) }));
    }
  };

  const handleCurrencyChange = (e) => {
    setSelectedCurrency(e.target.value);
  };

  // Reset form when reset state changes
  useEffect(() => {
    // This effect runs when reset changes
  }, [reset]);

  return (
    <div className={"custForm"}>
      {renderTitle()}
      <div className={["viewTitle"]}>Create New Group</div>
      <form onSubmit={() => {}} className={["form"]}>
        <div className={["form-group"]}>
          <label>
            Group Name <span>*</span>
          </label>
          <FontAwesomeIcon
            className={["icon", checker(field.name.state).style].join(" ")}
            icon={["fas", checker(field.name.state).icon]}
          />
          <div className={["field"]}>
            <input
              type={"text"}
              className={["form-control"]}
              id={"name"}
              placeholder={"enter group name"}
              value={field.name.value}
              onChange={valueChanged}
            />
            <span>{field.name.message}</span>
          </div>
        </div>

        <div className={["form-group"]}>
          <label htmlFor="group">
            Base currency <span>*</span>
          </label>
          <FontAwesomeIcon
            className={"icon correct"}
            icon={["fas", "check-circle"]}
          />
          <select
            className="form-control"
            id="group"
            onChange={handleCurrencyChange}
            value={selectedCurrency}
          >
            {currencies.map((item) => (
              <option value={item} key={item}>
                {item}
              </option>
            ))}
          </select>
        </div>

        <div className="form-group">
          <label>New level name</label>
          <div className="multipart">
            <div className={["field"]}>
              <div className={"part"}>
                <input
                  ref={newLevelRef}
                  type={"text"}
                  className={["form-control", "custField"].join(" ")}
                  id={"name"}
                  placeholder={"enter level name"}
                />
                <button
                  type={"button"}
                  onClick={() => add(newLevelRef.current.value)}
                  className={["custBtn", "add"].join(" ")}
                >
                  <FontAwesomeIcon
                    className={["icon", checker(field.levels.state).style].join(
                      " "
                    )}
                    icon={"plus"}
                  />
                </button>
              </div>
            </div>
          </div>
        </div>

        <div className={["form-group"]}>
          <label>
            User levels <span>*</span>
          </label>
          <div className={"multipart"}>
            {field.levels.value.map((data, key) => {
              return (
                <div className={["field"]} key={key}>
                  <div className={"part"}>
                    <FontAwesomeIcon
                      className={["icon", checker(data.state).style].join(" ")}
                      icon={["fas", checker(data.state).icon]}
                    />
                    <input
                      type={"number"}
                      disabled
                      className={["form-control", "level"].join(" ")}
                      id={"id"}
                      placeholder={"level"}
                      value={data.id}
                      data-key={key}
                      onChange={valueChanged}
                      data-field={"levels"}
                    />
                    <input
                      type={"text"}
                      disabled
                      className={["form-control", "custField"].join(" ")}
                      id={"name"}
                      placeholder={"enter level name"}
                      value={data.name}
                      data-key={key}
                      onChange={valueChanged}
                      data-field={"levels"}
                    />

                    {key !== 0 && (
                      <button
                        type={"button"}
                        onClick={() => remove(key)}
                        className={["custBtn", "remove"].join(" ")}
                      >
                        <FontAwesomeIcon
                          className={[
                            "icon",
                            checker(field.levels.state).style,
                          ].join(" ")}
                          icon={"minus"}
                        />
                      </button>
                    )}
                  </div>
                  <span>{data.message}</span>
                </div>
              );
            })}
          </div>
        </div>

        <div className={["form-group"]}>
          <label>
            Account Expiration <span>*</span>
          </label>
          <FontAwesomeIcon
            className={["icon", checker(field.accntExp.state).style].join(" ")}
            icon={["fas", checker(field.accntExp.state).icon]}
          />
          <div className={["date"].join(" ")}>
            <DatePicker
              className={["form-control"]}
              selected={field.accntExp.value}
              onChange={dateChange}
            />
          </div>
        </div>

        {form.message ? (
          <div className={["message", "form-group"].join(" ")}>
            <FontAwesomeIcon
              className={["icon", "correct"].join(" ")}
              icon={"check-circle"}
            />
            {form.message}
          </div>
        ) : (
          <div />
        )}

        <button
          type={"button"}
          className={["btn btn-primary"]}
          disabled={!form.state}
          onClick={submit}
        >
          Create
        </button>
        <button
          type={"button"}
          onClick={resetForm}
          className={["btn btn-primary", "reset"].join(" ")}
        >
          Reset
        </button>
      </form>
    </div>
  );
}

export default CreateGroup;
